import { render, staticRenderFns } from "./widget-template-selector.vue?vue&type=template&id=16d980f2&scoped=true&"
import script from "./widget-template-selector.vue?vue&type=script&lang=js&"
export * from "./widget-template-selector.vue?vue&type=script&lang=js&"
import style0 from "./widget-template-selector.vue?vue&type=style&index=0&id=16d980f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d980f2",
  null
  
)

export default component.exports